import React from 'react';
import styled from '@emotion/native';
import { green, sand } from '@/shared/styles/colors';
import { ActivityIndicator } from 'react-native-paper';

interface Props {
  overlay?: boolean;
}

export const FullScreenLoader = ({ overlay }: Props) => {
  return (
    <LoadingBackground overlay={overlay}>
      <ActivityIndicator size="large" color={green} />
    </LoadingBackground>
  );
};

const LoadingBackground = styled.View<{ overlay?: boolean }>(({ overlay }) => ({
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: sand,
  ...(overlay && {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1000,
  }),
}));
